import React from 'react'
import '../../styles/Search.scss'
import Image1 from '../../assets/imgs/stylers-images/image1.png'

const FeaturedServiceCard = ({
  service,
  name,
  imageUrl,
  className,
  component = '',
}) => {
  return (
    <div className="feature-service-card">
      <img
        src={service?.primary_image}
        // alt="Styles"
        // width="100%"
        height={240}
        style={{ borderRadius: '20px', objectFit: 'cover' }}
        className={`w-100 featured-service-card-image ${className}`}
      />
      <div
        className="text-center feature-service-card-desc py-1 position-relative py-2"
        style={{ width: '100%' }}
      >
        <p
          className="fs-20 font-weight-bold m-0 text-capitalize"
          style={{ wordBreak: 'break-all', padding: '0 15px' }}
        >
          {service?.subservice?.name ?? 'No service title'}
        </p>
        <p className="fs-16 m-0">{service?.providers + ' service providers'}</p>
      </div>
    </div>
  )
}

export default FeaturedServiceCard
